export default "__VITE_ASSET__B3d8Y65$__"